import * as React from 'react';
import { useFormikContext } from 'formik';
import { Button, ButtonProps } from './Button';

interface Props {
  disabled?: boolean;
  loading?: boolean;
}

export type SubmitButtonProps = Props & ButtonProps;

export const SubmitButton = ({
  loading,
  disabled,
  children,
  ...props
}: SubmitButtonProps) => {
  const formikContext = useFormikContext();

  const isLoading =
    loading ||
    (loading === undefined && formikContext && formikContext.isSubmitting);

  return (
    <Button
      type="submit"
      {...props}
      disabled={isLoading || disabled}
      isLoading={isLoading}
    >
      {children}
    </Button>
  );
};
